<div class="flex max-w-full flex-col items-end gap-2">
	<div
		class="inline-flex h-8 shrink-0 items-center rounded-md border-2 border-[#CFE3FF] bg-white p-0.5"
		role="group"
		aria-label="Date filter"
	>
		<button
			type="button"
			class="h-full cursor-pointer rounded px-3 text-xs font-semibold"
			[class.bg-violet]="!dateFilterEnabled"
			[class.text-white]="!dateFilterEnabled"
			[class.text-grey-40]="dateFilterEnabled"
			(click)="setDateFilterEnabled(false)"
		>
			All dates
		</button>
		<button
			type="button"
			class="h-full cursor-pointer rounded px-3 text-xs font-semibold"
			[class.bg-violet]="dateFilterEnabled"
			[class.text-white]="dateFilterEnabled"
			[class.text-grey-40]="!dateFilterEnabled"
			(click)="setDateFilterEnabled(true)"
		>
			Date range
		</button>
	</div>
	@if (dateFilterEnabled) {
		<div class="flex max-w-full flex-col items-end gap-2 sm:flex-row sm:items-center">
			<div class="flex items-center gap-2">
				<span class="text-xs text-grey-40">Start Date:</span>
				<app-cbta-datepicker
					placeHolder="Select date"
					[defaultValue]="startDate"
					[format]="DATE_FORMAT.INPUT_DISPLAY_DATE_FORMAT"
					(selectedDateChange)="handleStartDateChange($event)"
				></app-cbta-datepicker>
			</div>
			<div class="flex items-center gap-2">
				<span class="text-xs text-grey-40">End Date:</span>
				<app-cbta-datepicker
					placeHolder="Select date"
					[defaultValue]="endDate"
					[format]="DATE_FORMAT.INPUT_DISPLAY_DATE_FORMAT"
					(selectedDateChange)="handleEndDateChange($event)"
				></app-cbta-datepicker>
			</div>
		</div>
	}
</div>
